import {Colors} from '@eitje/assets'

export const FIRM_STATUS_ICON_MAPPING = {
	demo: {icon: 'circle', color: Colors.darkGreen},
	expired: {icon: 'circle', color: Colors.darkRed},
	eitje: {icon: 'dot', color: Colors.mediumBlue},
	active: {icon: 'dot', color: Colors.mediumGreen},
	inactive: {icon: 'dot', color: Colors.mediumRed},
	unattached: {icon: 'circle', color: Colors.darkPurple},
}
